<template>
  <b-row>
    <b-col md="4">
      <label>Unidad de negocio*</label>
    </b-col>
    <b-col md="8">
      <select-box
        :value="ofertaBase.unidadNegocioId"
        :disabled="disabled"
        :options="unidadesNegocio"
        @input="cambiarUnidadNegocio"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
    ...mapState(useOfertaFormStore, ["ofertaBase", "unidadNegocio", "unidadesNegocio"]),
  },
  methods: {
    ...mapActions(useOfertaFormStore, ["cambiarUnidadNegocio"]),
  },
};
</script>
